import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const Ads = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Skapa annonser</title>
        <meta
          name="description"
          content="Vi ser över era befintliga jobbannonser eller skapar nya jobbannonser för att se till att fler 
          kvinnliga kandidater söker till tjänsterna."
        />
        <meta property="og:title" content="We Exist - Skapa annonser" />
        <meta
          property="og:description"
          content="Vi ser över era befintliga jobbannonser eller skapar nya jobbannonser för att se till att fler kvinnliga kandidater söker till tjänsterna. Vi ser över era befintliga jobbannonser eller skapar nya jobbannonser för att se till att fler kvinnliga kandidater söker till tjänsterna. Vi ser över era befintliga jobbannonser eller skapar nya jobbannonser för att se till att fler kvinnliga kandidater söker till tjänsterna. "
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Skapa annonser" />
      <ServicePageWrapper>
        <img src="./service-images/skapa-annonser.jpg" alt="woman and laptop" />
        <p>
          Att skapa en attraktiv annons som upplevs relevant i både färg, bild
          och text är oerhört viktigt för att nå de kvinnor som ni letar efter.
          Och ändå är det många företag som snubblar just här. Vi vet att
          annonsen är ett avgörande steg i starten på en rekryteringsprocess så
          därför erbjuder vi hjälp från framtagning av kravprofil till skapandet
          av en effektiv och attraherande annons. Vi kan också titta på era
          befintliga annonser och ser hur ni kan uppdatera text- och bildspråk
          så att ni ökar chansen att kvinnor söker tjänsten. Visste du till
          exempel att om ni annonserar efter nästa “tech ninja” eller använder
          adjektiven “vass”, “snabb” eller “skarp” så kommer majoriteten av alla
          kvinnliga kandidater att scrolla förbi just er annons. Annonser som
          attraherar kvinnor är också ofta favoriter även hos män, så chansen
          att hitta bra kandidater ökar maximalt! Psst, vill ni sticka ut lite
          extra har vi även en premiumtjänst! Fråga oss så berättar vi.
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
